import React from 'react';
import { AvatarConfig } from '../../types/user';

interface Props {
  avatar: AvatarConfig;
  size?: number;
  isMoving?: boolean;
  isMe?: boolean;
}

function AvatarDisplayInner({ avatar, size = 40, isMoving = false, isMe = false }: Props) {
  const radius = avatar.shape === 'circle' ? '50%'
    : avatar.shape === 'rounded' ? '30%'
    : '30% 0';

  const hasPhoto = !!avatar.profilePhoto;

  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      {isMoving && (
        <span
          className="stabeon-pulse"
          style={{
            position: 'absolute', inset: -5, borderRadius: '50%',
            border: '2px solid #facc15', opacity: 0.7,
          }}
        />
      )}
      <div
        style={{
          width: size, height: size,
          borderRadius: radius,
          background: hasPhoto ? 'transparent' : avatar.bgColor,
          border: isMe ? '2px solid #7c3aed' : `2px solid ${avatar.borderColor}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: size * 0.48,
          boxSizing: 'border-box',
          boxShadow: isMe ? '0 0 0 2px #7c3aed44' : undefined,
          overflow: 'hidden',
        }}
      >
        {hasPhoto ? (
          <img
            src={avatar.profilePhoto}
            alt=""
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          avatar.emoji
        )}
      </div>
    </div>
  );
}

export const AvatarDisplay = React.memo(AvatarDisplayInner);
